import React from 'react'
import gql from 'graphql-tag'
import { get } from 'lodash'
import QueryManager from './Query'
import { any } from 'prop-types'

export const GET_PICKING_STATS_TOTALS = gql`
  query getPickingStoreStats($input: PickingStatsInput) {
    getPickingStoreStatsBy(input: $input) {
      results {
        idStore
        facturado
        pickeadoPorFacturar
        cancel
        inPicking
        pendienteAuditoria
        pedientePicking
      }
    }
  }
`

const GetPickingStoreStats = ({ children, ...props }) => (
  <QueryManager query={GET_PICKING_STATS_TOTALS} {...props}>
    {({ data, loading, refetch, networkStatus }) => (
      children({
        data: get(data, 'getPickingStoreStatsBy.results',[]),
        refetch,
        loading,
        networkStatus
      })
    )}
  </QueryManager>
)

GetPickingStoreStats.propTypes = {
  children: any
}

export default GetPickingStoreStats
